<template>
  <div class="container">
    <div class="advantage adaption">
      <div>
        <div class="headline himalaya">A<span>dvantage</span></div>
        <span class="title">双湃优势</span>
        <span class="text">工业安全大数据，超过15年经验的安全及工业控制专家团队</span>
      </div>
      <img ref="arrow" class="arrow" v-lazy="require('../../assets/index/advantage/arrow.svg')"
           @click="isEnd ? scrollStart() : scrollEnd()"/>
    </div>
    <div class="item-container adaption-right-full">
      <div class="shade"></div>
      <section ref="itemContainer" class="advantage-item-section">
        <div class="item">
          <img class="item-img" v-lazy="require('../../assets/index/advantage/item1.png')">
          <div class="item-des">
            <div class="item-num num"><span>01</span></div>
            <div class="item-text">Deep analysis technology of industrial protocol</div>
            <div class="item-name">工业协议深度解析技术</div>
          </div>
        </div>
        <div class="item">
          <img class="item-img" v-lazy="require('../../assets/index/advantage/item2.png')">
          <div class="item-des">
            <div class="item-num num"><span>02</span></div>
            <div class="item-text">Asset discovery technology based on hidden detection and heuristic</div>
            <div class="item-name">基于隐匿探测与启发式的资产发现技术</div>
          </div>
        </div>
        <div class="item">
          <img class="item-img" v-lazy="require('../../assets/index/advantage/item3.png')">
          <div class="item-des">
            <div class="item-num num"><span>03</span></div>
            <div class="item-text">"White list + machine learning" safety baseline Technology</div>
            <div class="item-name">“白名单+机器学习”安全基线技术</div>
          </div>
        </div>
        <div class="item">
          <img class="item-img" v-lazy="require('../../assets/index/advantage/item4.png')">
          <div class="item-des">
            <div class="item-num num"><span>04</span></div>
            <div class="item-text">Asset recognition technology based on syntactic analysis and knowledge
              map
            </div>
            <div class="item-name">基于句法分析与知识图谱的资产识别技术</div>
          </div>
        </div>
        <div class="item">
          <img class="item-img" v-lazy="require('../../assets/index/advantage/item5.png')">
          <div class="item-des">
            <div class="item-num num"><span>05</span></div>
            <div class="item-text">Professional Intranet and Internet Monitoring Services</div>
            <div class="item-name">专业的全网、内外网监测服务</div>
          </div>
        </div>
        <div class="item">
          <img class="item-img" v-lazy="require('../../assets/index/advantage/item6.png')">
          <div class="item-des">
            <div class="item-num num"><span>06</span></div>
            <div class="item-text">Managed Security Service for Industrial Internet</div>
            <div class="item-name">全面的工业互联网安全托管服务</div>
          </div>
        </div>
      </section>
    </div>
    <div class="advantage adaption">
      <div class="advantage-btn-container">
        <div class="Wayra advantage-btn" @click="click">了解安全产品</div>
        <!--        <div class="Wayra-primary advantage-btn-primary" @click="download('双湃技术专利')"><span class="left">双湃技术专利</span><span class="right">PDF</span></div>-->
        <!--        <div class="Wayra-primary advantage-btn-primary soft" @click="download('双湃软著')"><span class="left">双湃软著</span><span class="right">PDF</span></div>-->
      </div>
    </div>
  </div>
</template>

<script>

import {top} from "../../utils/common";

export default {
  name: "Advantage",
  data() {
    return {
      scrollWidth: 0,
      isEnd: false
    };
  },
  methods: {
    scrollEnd() {
      let el = this.$refs.itemContainer;

      this.scrollWidth += el.scrollWidth / el.childNodes.length;
      el.style.transform = `translateX(-${this.scrollWidth}px)`;
      if (this.scrollWidth >= el.offsetLeft + el.scrollWidth - el.clientWidth) {
        this.isEnd = true;
        this.$refs.arrow.style.transform = "scaleX(-1)";
      }
    },
    scrollStart() {
      let el = this.$refs.itemContainer;

      el.style.transform = "";
      this.$refs.arrow.style.transform = "";
      this.scrollWidth = 0;
      this.isEnd = false;
    },
    click() {
      top();
      this.$router.push("/product");
    },
    download(value) {
      window.open(`/file/${value}.pdf`);
    }
  }
};
</script>

<style scoped lang="less">
.transition(@time: 0.3s) {
  transition: all @time ease-in-out
}

;
.container {
  padding-top: 0;
  background: #FFFFFF;
}

.item-container {
  margin-top: 60px;
  overflow: hidden;
}

.shade {
  position: absolute;
  right: 0;
  z-index: 1;
  width: 275px;
  height: 417px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.5) 15.64%, rgba(255, 255, 255, 0) 100%);
}

.advantage-item-section {
  display: flex;
  .transition;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  min-width: 305px;
  height: 417px;
  margin-right: 24px;
  background: linear-gradient(180deg, #214692 0%, #2852A7 100%);

  .item-img {
  }

  .item-des {
    position: relative;
    padding: 0 29px 0 18px;
    width: calc(100% - 29px - 18px);

    .item-text {
      position: absolute;
      top: 40px;
      font-weight: bold;
      font-size: 14px;
      line-height: 120%;
      color: #FFFFFF;
      opacity: 0.7;
    }

    .item-num {
      height: 100px;
      font-size: 100px;
      color: #FFFFFF;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);

      span {
        opacity: 0.07;
      }
    }

    .item-name {
      height: 60px;
      padding-top: 10px;
      font-size: 18px;
      line-height: 120%;
      color: #FFFFFF;
    }
  }
}

.advantage {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  .arrow {
    align-self: flex-end;
    margin-left: auto;
    cursor: pointer;
    .transition;
  }

  .headline {
    margin-top: 90px;
    height: 85px;
    font-size: 120px;
    color: #929AB9;

    span {
      font-size: 70px;
    }
  }

  .title {
    font-size: 36px;
    color: #232E55;
  }

  .text {
    margin-left: 20px;
    font-size: 16px;
    color: #707783;
  }

  .advantage-btn-container {
    margin-top: 25px;
    margin-bottom: 130px;
  }

  .advantage-btn {
    display: inline-block;
    width: 162px;
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
  }

  .advantage-btn-primary {
    display: inline-block;
    width: 203px;
    margin-left: 16px;
    vertical-align: middle;
    text-align: center;

    .left {
      vertical-align: middle;
      font-size: 18px;
    }

    .right {
      margin-left: 21px;
      vertical-align: middle;
      font-size: 12px;
    }
  }

  .soft {
    width: 150px;
  }
}
</style>
